var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"totalregisters"},[_c('p',{staticClass:"category",staticStyle:{"text-transform":"none"}},[_vm._v("Total: "+_vm._s(_vm.total)+" "+_vm._s(_vm.totalText))])])}
var staticRenderFns = []

export { render, staticRenderFns }